import { gql } from '@apollo/client';

const GET_ORGS_WITH_UNITS = gql`
  query GetOrgsWithUnits($orgId: Int) {
    orgsWithUnits(orgId: $orgId) {
      Id
      Name
      MddapOrgUnits {
        Id
        Name
        Fei
        IsActive
      }
    }
  }
`;

export default GET_ORGS_WITH_UNITS;
